// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-it-works-section {
  background: #f8fafc;
}

.how-title {
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #0b1c39;
  padding-top: 8vh;
}

.how-subtitle {
  font-size: 18px;
  color: #555;
}

.how-card {
  background: #ffffff;
  padding: 35px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  margin-bottom: 30px;
}

.how-card h2 {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #0b1c39;
}

.step-box {
  margin-bottom: 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid #eaeaea;
}

.step-box h4 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #198754;
}

.step-box p,
.step-box li,
.how-card p {
  font-size: 16px;
  line-height: 1.7;
  color: #444;
}

.step-box ul {
  padding-left: 20px;
  margin-top: 10px;
}

@media (max-width: 767.98px) {
  .how-title {
    font-size: 28px;
  }

  .how-card {
    padding: 22px;
  }

  .how-card h2 {
    font-size: 24px;
  }

  .step-box h4 {
    font-size: 18px;
  }

  .how-card p, .steps li, .how-subtitle{
    font-size: 16px!important;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/HowItWorks.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".how-it-works-section {\n  background: #f8fafc;\n}\n\n.how-title {\n  font-size: 38px;\n  font-weight: 700;\n  margin-bottom: 15px;\n  color: #0b1c39;\n  padding-top: 8vh;\n}\n\n.how-subtitle {\n  font-size: 18px;\n  color: #555;\n}\n\n.how-card {\n  background: #ffffff;\n  padding: 35px;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  margin-bottom: 30px;\n}\n\n.how-card h2 {\n  font-size: 30px;\n  font-weight: 700;\n  margin-bottom: 25px;\n  color: #0b1c39;\n}\n\n.step-box {\n  margin-bottom: 22px;\n  padding-bottom: 18px;\n  border-bottom: 1px solid #eaeaea;\n}\n\n.step-box h4 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #198754;\n}\n\n.step-box p,\n.step-box li,\n.how-card p {\n  font-size: 16px;\n  line-height: 1.7;\n  color: #444;\n}\n\n.step-box ul {\n  padding-left: 20px;\n  margin-top: 10px;\n}\n\n@media (max-width: 767.98px) {\n  .how-title {\n    font-size: 28px;\n  }\n\n  .how-card {\n    padding: 22px;\n  }\n\n  .how-card h2 {\n    font-size: 24px;\n  }\n\n  .step-box h4 {\n    font-size: 18px;\n  }\n\n  .how-card p, .steps li, .how-subtitle{\n    font-size: 16px!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
